function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("path", {
  d: "M0 0h48v48H0z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M28 12h14v10H28V12Zm-10 0c3.3 0 6 2.7 6 6s-2.7 6-6 6-6-2.7-6-6 2.7-6 6-6ZM6 33.18C6 28.16 13.94 26 18 26s12 2.16 12 7.16V36H6v-2.82Z",
  fill: "#EBF7FB",
  fillRule: "nonzero"
}), /*#__PURE__*/React.createElement("path", {
  d: "M44 6H4c-2.2 0-4 1.8-4 4v28c0 2.2 1.8 4 4 4h40c2.2 0 3.98-1.8 3.98-4L48 10c0-2.2-1.8-4-4-4Zm0 32H4V10h40v28Zm-2-26H28v10h14V12Zm-2 4-5 3.5-5-3.5v-2l5 3.5 5-3.5v2Zm-22 8c3.3 0 6-2.7 6-6s-2.7-6-6-6-6 2.7-6 6 2.7 6 6 6Zm0-8c1.1 0 2 .9 2 2s-.9 2-2 2-2-.9-2-2 .9-2 2-2Zm12 17.18c0-5-7.94-7.16-12-7.16S6 28.18 6 33.18V36h24v-2.82ZM10.96 32c1.48-1 4.44-2 7.04-2 2.6 0 5.54.98 7.04 2H10.96Z",
  fill: "#52BAED",
  fillRule: "nonzero"
}));

function SvgContactCard(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgContactCard);
export default __webpack_public_path__ + "static/media/ContactCard.dabc2067.svg";
export { ForwardRef as ReactComponent };